import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _13830b58 = () => interopDefault(import('../pages/aboutUs/index.vue' /* webpackChunkName: "pages/aboutUs/index" */))
const _9c977408 = () => interopDefault(import('../pages/backup-solutions/index.vue' /* webpackChunkName: "pages/backup-solutions/index" */))
const _6297c014 = () => interopDefault(import('../pages/cdn/index.vue' /* webpackChunkName: "pages/cdn/index" */))
const _b8c02c82 = () => interopDefault(import('../pages/cloud-migration/index.vue' /* webpackChunkName: "pages/cloud-migration/index" */))
const _3ac19976 = () => interopDefault(import('../pages/cloud-security/index.vue' /* webpackChunkName: "pages/cloud-security/index" */))
const _604b4564 = () => interopDefault(import('../pages/colocation/index.vue' /* webpackChunkName: "pages/colocation/index" */))
const _b11a0700 = () => interopDefault(import('../pages/compute/index.vue' /* webpackChunkName: "pages/compute/index" */))
const _01bb72e7 = () => interopDefault(import('../pages/contactUs/index.vue' /* webpackChunkName: "pages/contactUs/index" */))
const _395c6edd = () => interopDefault(import('../pages/data-resilience/index.vue' /* webpackChunkName: "pages/data-resilience/index" */))
const _d3470216 = () => interopDefault(import('../pages/datacenter-services/index.vue' /* webpackChunkName: "pages/datacenter-services/index" */))
const _1ce4b26b = () => interopDefault(import('../pages/ddos-protection/index.vue' /* webpackChunkName: "pages/ddos-protection/index" */))
const _4326888e = () => interopDefault(import('../pages/dedicated-server/index.vue' /* webpackChunkName: "pages/dedicated-server/index" */))
const _177649aa = () => interopDefault(import('../pages/devops/index.vue' /* webpackChunkName: "pages/devops/index" */))
const _6f37e96c = () => interopDefault(import('../pages/disaster-recovery/index.vue' /* webpackChunkName: "pages/disaster-recovery/index" */))
const _1ac1cc1c = () => interopDefault(import('../pages/dns/index.vue' /* webpackChunkName: "pages/dns/index" */))
const _70a175d3 = () => interopDefault(import('../pages/dns-proxy/index.vue' /* webpackChunkName: "pages/dns-proxy/index" */))
const _3a7cbe5a = () => interopDefault(import('../pages/enterprise-services/index.vue' /* webpackChunkName: "pages/enterprise-services/index" */))
const _87e075ca = () => interopDefault(import('../pages/enterprise-solutions/index.vue' /* webpackChunkName: "pages/enterprise-solutions/index" */))
const _50ab1b3b = () => interopDefault(import('../pages/europe-vps/index.vue' /* webpackChunkName: "pages/europe-vps/index" */))
const _17bb2c6c = () => interopDefault(import('../pages/hourly-vps/index.vue' /* webpackChunkName: "pages/hourly-vps/index" */))
const _c76ca75e = () => interopDefault(import('../pages/infrastructure-services/index.vue' /* webpackChunkName: "pages/infrastructure-services/index" */))
const _4540ea2f = () => interopDefault(import('../pages/iran-vps/index.vue' /* webpackChunkName: "pages/iran-vps/index" */))
const _4c12c6a4 = () => interopDefault(import('../pages/isolated-cloud/index.vue' /* webpackChunkName: "pages/isolated-cloud/index" */))
const _716bbe33 = () => interopDefault(import('../pages/kubernetes/index.vue' /* webpackChunkName: "pages/kubernetes/index" */))
const _c4e013ae = () => interopDefault(import('../pages/linux-vps/index.vue' /* webpackChunkName: "pages/linux-vps/index" */))
const _1195322e = () => interopDefault(import('../pages/loadbalancer/index.vue' /* webpackChunkName: "pages/loadbalancer/index" */))
const _6ff7f492 = () => interopDefault(import('../pages/network/index.vue' /* webpackChunkName: "pages/network/index" */))
const _d7a9a1cc = () => interopDefault(import('../pages/object-storage/index.vue' /* webpackChunkName: "pages/object-storage/index" */))
const _5cb5da10 = () => interopDefault(import('../pages/paas/index.vue' /* webpackChunkName: "pages/paas/index" */))
const _3f61d1a5 = () => interopDefault(import('../pages/pam/index.vue' /* webpackChunkName: "pages/pam/index" */))
const _307821df = () => interopDefault(import('../pages/privateCloud/index.vue' /* webpackChunkName: "pages/privateCloud/index" */))
const _6a13e351 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _43892bec = () => interopDefault(import('../pages/secure-workspace/index.vue' /* webpackChunkName: "pages/secure-workspace/index" */))
const _17d1cfeb = () => interopDefault(import('../pages/siem/index.vue' /* webpackChunkName: "pages/siem/index" */))
const _b49a1660 = () => interopDefault(import('../pages/soc/index.vue' /* webpackChunkName: "pages/soc/index" */))
const _2ae55323 = () => interopDefault(import('../pages/solutions/index.vue' /* webpackChunkName: "pages/solutions/index" */))
const _74ba8f72 = () => interopDefault(import('../pages/virtual-server/index.vue' /* webpackChunkName: "pages/virtual-server/index" */))
const _78edadb2 = () => interopDefault(import('../pages/vpc/index.vue' /* webpackChunkName: "pages/vpc/index" */))
const _718e4c7c = () => interopDefault(import('../pages/vps/index.vue' /* webpackChunkName: "pages/vps/index" */))
const _9a93c836 = () => interopDefault(import('../pages/waf/index.vue' /* webpackChunkName: "pages/waf/index" */))
const _647bfdf8 = () => interopDefault(import('../pages/windows-vps/index.vue' /* webpackChunkName: "pages/windows-vps/index" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aboutUs",
    component: _13830b58,
    name: "aboutUs"
  }, {
    path: "/backup-solutions",
    component: _9c977408,
    name: "backup-solutions"
  }, {
    path: "/cdn",
    component: _6297c014,
    name: "cdn"
  }, {
    path: "/cloud-migration",
    component: _b8c02c82,
    name: "cloud-migration"
  }, {
    path: "/cloud-security",
    component: _3ac19976,
    name: "cloud-security"
  }, {
    path: "/colocation",
    component: _604b4564,
    name: "colocation"
  }, {
    path: "/compute",
    component: _b11a0700,
    name: "compute"
  }, {
    path: "/contactUs",
    component: _01bb72e7,
    name: "contactUs"
  }, {
    path: "/data-resilience",
    component: _395c6edd,
    name: "data-resilience"
  }, {
    path: "/datacenter-services",
    component: _d3470216,
    name: "datacenter-services"
  }, {
    path: "/ddos-protection",
    component: _1ce4b26b,
    name: "ddos-protection"
  }, {
    path: "/dedicated-server",
    component: _4326888e,
    name: "dedicated-server"
  }, {
    path: "/devops",
    component: _177649aa,
    name: "devops"
  }, {
    path: "/disaster-recovery",
    component: _6f37e96c,
    name: "disaster-recovery"
  }, {
    path: "/dns",
    component: _1ac1cc1c,
    name: "dns"
  }, {
    path: "/dns-proxy",
    component: _70a175d3,
    name: "dns-proxy"
  }, {
    path: "/enterprise-services",
    component: _3a7cbe5a,
    name: "enterprise-services"
  }, {
    path: "/enterprise-solutions",
    component: _87e075ca,
    name: "enterprise-solutions"
  }, {
    path: "/europe-vps",
    component: _50ab1b3b,
    name: "europe-vps"
  }, {
    path: "/hourly-vps",
    component: _17bb2c6c,
    name: "hourly-vps"
  }, {
    path: "/infrastructure-services",
    component: _c76ca75e,
    name: "infrastructure-services"
  }, {
    path: "/iran-vps",
    component: _4540ea2f,
    name: "iran-vps"
  }, {
    path: "/isolated-cloud",
    component: _4c12c6a4,
    name: "isolated-cloud"
  }, {
    path: "/kubernetes",
    component: _716bbe33,
    name: "kubernetes"
  }, {
    path: "/linux-vps",
    component: _c4e013ae,
    name: "linux-vps"
  }, {
    path: "/loadbalancer",
    component: _1195322e,
    name: "loadbalancer"
  }, {
    path: "/network",
    component: _6ff7f492,
    name: "network"
  }, {
    path: "/object-storage",
    component: _d7a9a1cc,
    name: "object-storage"
  }, {
    path: "/paas",
    component: _5cb5da10,
    name: "paas"
  }, {
    path: "/pam",
    component: _3f61d1a5,
    name: "pam"
  }, {
    path: "/privateCloud",
    component: _307821df,
    name: "privateCloud"
  }, {
    path: "/products",
    component: _6a13e351,
    name: "products"
  }, {
    path: "/secure-workspace",
    component: _43892bec,
    name: "secure-workspace"
  }, {
    path: "/siem",
    component: _17d1cfeb,
    name: "siem"
  }, {
    path: "/soc",
    component: _b49a1660,
    name: "soc"
  }, {
    path: "/solutions",
    component: _2ae55323,
    name: "solutions"
  }, {
    path: "/virtual-server",
    component: _74ba8f72,
    name: "virtual-server"
  }, {
    path: "/vpc",
    component: _78edadb2,
    name: "vpc"
  }, {
    path: "/vps",
    component: _718e4c7c,
    name: "vps"
  }, {
    path: "/waf",
    component: _9a93c836,
    name: "waf"
  }, {
    path: "/windows-vps",
    component: _647bfdf8,
    name: "windows-vps"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
